export default "__VITE_ASSET__120fd079__"